import { render, staticRenderFns } from "./currentScore.vue?vue&type=template&id=a736fce6&scoped=true&"
import script from "./currentScore.vue?vue&type=script&lang=js&"
export * from "./currentScore.vue?vue&type=script&lang=js&"
import style0 from "./currentScore.vue?vue&type=style&index=0&id=a736fce6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a736fce6",
  null
  
)

export default component.exports